import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ActionButtonComponent } from '../action-button/action-button.component';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css'],
  imports: [ActionButtonComponent],
})
export class PageNotFoundComponent {
  constructor(private readonly router: Router) {}

  toGoBack() {
    this.router.navigate(['/dashboard']);
  }
}
